export const getDiffInDays = (then, now) => {
    let days = then.diff(now, 'days');
    return days > 0 ? days : 0;
};

export const getDiffInHours = (then, now) => {
    let days = getDiffInDays(then, now);
    now.add(days, 'days');
    let hours = then.diff(now, 'hours');
    return hours > 0 ? hours : 0;
};

export const getDiffInMinutes = (then, now) => {
    let hours = getDiffInHours(then, now);
    now.add(hours, 'hours');
    let minutes = then.diff(now, 'minutes');
    return minutes > 0 ? minutes : 0;
};

export const getDiffInSeconds = (then, now) => {
    let minutes = getDiffInMinutes(then, now);
    now.add(minutes, 'minutes');
    let seconds = then.diff(now, 'seconds');
    return seconds > 0 ? seconds : 0;
};

export const displayNumber = (value, separateDigits = false) => {
    let number = value < 10 ? '0' + value : value;

    if (separateDigits) {
        number = number.toString();
        number = `<span>${number.slice(0, 1)}</span><span>${number.slice(1, 2)}</span>`;
    }

    return number;
};
